import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import { AppProvider } from "@/lib/AppContext";
import api, { onAuthEvent } from "@/lib/api";

function App() {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  const loadMe = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data.user);
    } catch {
      setUser(null);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    loadMe();
    return onAuthEvent((event) => {
      if (event === "logged_out") setUser(null);
      if (event === "password_change_required") setUser((u) => (u ? { ...u, must_change_password: true } : u));
    });
  }, [loadMe]);

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
  };

  if (!checked) return null;

  return (
    <>
      <Toaster theme="dark" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/" /> : <LoginPage onLogin={setUser} />}
          />
          <Route
            path="/*"
            element={
              !user ? <Navigate to="/login" />
                : user.must_change_password
                  ? <ChangePasswordPage user={user} onDone={loadMe} onLogout={handleLogout} />
                  : <AppProvider><DashboardPage user={user} onLogout={handleLogout} /></AppProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
